module.exports = __webpack_public_path__ + "img/book1.3fe04bcb.png";